import { Navigate, useParams } from 'react-router-dom';
import SupportChannelTab from '../Components/Support/SupportChannelTab';
import {
  SUPPORT_CHANNELS,
  SupportChannelKey,
} from '../Types/SupportType';

/**
 * Validates the `:channel` route segment before rendering the tab.
 *
 * <p>The tab component filters on this value straight against `visitor_session.first_source`, so
 * an unrecognised key would silently render an empty table - which reads as "no traffic" rather
 * than "wrong URL". Redirecting an unknown channel to the overview keeps a bad link from looking
 * like a real result.</p>
 */
function BusinessSupportChannelPage() {
  const { channel } = useParams<{ channel: string }>();

  if (!channel || !SUPPORT_CHANNELS.includes(channel as SupportChannelKey)) {
    return <Navigate to="/admin/support" replace />;
  }

  return <SupportChannelTab channel={channel as SupportChannelKey} />;
}

export default BusinessSupportChannelPage;
